import * as _ from 'underscore';

import BooleanField from '../../../../_common/platform/ts/BooleanField';
import NumberField from '../../../../_common/platform/ts/NumberField';
import SelectField from '../../../../_common/platform/ts/SelectField';

// Theme dispatcher module
import * as appTheme from '../../../../_common/platform/ts/appTheme';
import toolbarButtons from '../../../../pdc-platform/src/ts/themes/toolbarButtonsTheme';

// Any dependency themes, which should be initialized before this one
import { init as widgetTheme } from '../../../../pdc-platform/src/ts/themes/widgetTheme';
import { validators } from '../../../../_common/platform/ts/validators';
import * as Config from '../config';
//import { VARIABLE_PERIOD_END, VARIABLE_PERIOD_START } from '../../../../_common/platform/tsx/filtering/Constants';
import { periodFilterThemeFields } from '../../../../_common/platform/tsx/filtering/PeriodFiltersCreator';

// This array, which saves all glob objects, on which theme was initialized
// It's used to make sure that `init` is launched only once for each glob.
// Here, it's possible that platform will run init for widgetTheme more than 1 time.
const _init = [];

export function init(glob) {
    // If init already invoked – halt
    if (_.indexOf(_init, glob) !== -1) {
        return;
    }

    // Init parent theme
    widgetTheme(glob);

    // Register section, which will be displayed on the left of theme edit component
    appTheme.registerSections([
        {
            id: Config.themeId,
            name: 'Period Filter',
            parent: 'widget',

            themeType: 'Period Filter',
            visibility: ['application', 'workspace', 'pdc-widget-filter-period']
        }
    ]);

    // Register theme variables
    appTheme.registerVars([
        {
            id: periodFilterThemeFields.layoutType,
            param: new SelectField(glob, 'Layout Type', [], 'vertical', {
                values: ['vertical', 'horizontal'],
                display: ['vertical', 'horizontal']
            }),
            section: Config.themeId
        },
        {
            id: periodFilterThemeFields.verticalSpacing,
            param: new NumberField(
                glob,
                'Vertical Space Between Fields',
                [validators.number.not_negative, validators.number.integer],
                10
            ),
            section: Config.themeId
        },
        {
            id: periodFilterThemeFields.animationEnabled,
            param: new BooleanField(glob, 'Time Slider animation enabled', [], false),
            section: Config.themeId
        },
        {
            id: periodFilterThemeFields.usePlaceholder,
            param: new BooleanField(glob, 'Use placeholder instead the labels: From, To', [], false),
            section: Config.themeId
        },
        {
            id: periodFilterThemeFields.applyValueMode_useButtons,
            param: new BooleanField(glob, 'Show in the Picker Calendar the buttons: Today, Apply, Cancel', [], false),
            section: Config.themeId
        },
        {
            id: periodFilterThemeFields.currentDateMode,
            param: new SelectField(glob, 'Set current position for date navigation:', [], 'current', {
                values: ['current', 'datepicker'],
                display: ['Select Current Date', 'Pick the Date']
            }),
            section: Config.themeId
        },
        {
            id: periodFilterThemeFields.alignDatesForCalendarPeriod,
            param: new BooleanField(glob, 'Align Filter dates to Calendar period', [], false),
            section: Config.themeId
        }
        // {
        //     id: periodFilterThemeFields.putFromAndToValuesToVariables,
        //     param: new BooleanField(
        //         glob,
        //         `Put values of From and To to ${VARIABLE_PERIOD_START} and ${VARIABLE_PERIOD_END} variables`,
        //         [],
        //         true
        //     ),
        //     section: Config.themeId
        // }
    ]);

    toolbarButtons(
        glob,
        Config.themeId,
        Config.moduleName,
        periodFilterThemeFields.section_Buttons,
        periodFilterThemeFields.justifyButtons,
        periodFilterThemeFields.showResetButton,
        periodFilterThemeFields.resetButtonShowMode,
        periodFilterThemeFields.showApplyButton,
        periodFilterThemeFields.showRefreshButton,
        periodFilterThemeFields.refreshButtonShowMode,
        periodFilterThemeFields.buttonsPosition,
        periodFilterThemeFields.resetButtonMode
    );

    appTheme.registerPreRender(function (input) {
        const vars = {};

        return _.extend(input, vars);
    });

    _init.push(glob);
}
